export enum SSOConnectionEnvironmentTypeEnum {
    None = 0,
    Production = 1,
    Testing = 2,
    Development = 3,
}
